import { COURSE_DESCRIPTION_FOLD } from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'
import { useState } from 'react'

type Props = {
  courseName: CourseNameType
  hideReadMore?: boolean
}

const CourseDescription = ({ courseName, hideReadMore }: Props) => {
  const [showDescription, setShowDescription] = useState(false)

  const coursesData = COURSE_DESCRIPTION_FOLD[courseName]

  return (
    <div className="mb-10 flex flex-col text-grey lg:px-3 py-5">
      <h2 className="text-2xl font-600 mb-4 leading-tight">
        {coursesData.title}
      </h2>
      <div
        className="text-lg overflow-hidden transition-all duration-700"
        style={{
          maxHeight:
            !coursesData.description || showDescription ? '100vh' : '80px',
        }}
      >
        {coursesData.description && <p>{coursesData.description}</p>}
        <p className="flex flex-col space-y-4 mt-4">
          {coursesData.expandedDescription}
        </p>
      </div>
      {!hideReadMore && (
        <>
          {coursesData.readMoreLink && (
            <a
              href={coursesData.readMoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-left mt-3 focus:outline-none hover:text-orange"
            >
              Read more
            </a>
          )}
          {!coursesData.readMoreLink && (
            <button
              onClick={() => setShowDescription(!showDescription)}
              className="underline text-left mt-3 focus:outline-none hover:text-orange"
            >
              Show {showDescription ? 'less' : 'more'}
            </button>
          )}{' '}
        </>
      )}
    </div>
  )
}

export default CourseDescription
